// extracted by mini-css-extract-plugin
export default {"keyContact":"KeyContact_keyContact__m2eUY","title":"KeyContact_title__OXoBt","transparentLine":"KeyContact_transparentLine__GQn9D"};